import React from "react";
import { Box, FormControl, Select, MenuItem, styled } from "@mui/material";
import { COVERAGES } from "@platform/rfp-core";

import { sortProductsByCoverage } from "../../pages/RFP/utils";

export const StyledSelect = styled(Select)(({ theme }) => ({
  width: 195,
  color: theme.palette.brandPrimary.main,
  backgroundColor: "transparent",
  fontSize: 15,
  "& > div": {
    padding: "8px 22px",
  },
  "& > fieldset": {
    border: "none",
  },
  "& > svg": {
    color: theme.palette.brandPrimary.main,
  },
}));

const CoverageSelectionDropdown = ({ data, coverage, setCoverage }) => {
  const allCoverages = data?.[COVERAGES]
    ? sortProductsByCoverage(data[COVERAGES])
    : [];
  return (
    <Box ml={2}>
      <FormControl>
        <StyledSelect
          id="coverage-select"
          labelId="coverage-select-label"
          SelectDisplayProps={{ "data-testid": "add-coverage-select" }}
          value={coverage}
          displayEmpty
          renderValue={(value) => (
            <span
              style={{
                lineHeight: "24px",
                letterSpacing: "0.4px",
              }}
            >
              {value !== "" ? value : "ADD COVERAGE"}
            </span>
          )}
          onChange={(e) => setCoverage(e.target.value)}
          name="coverage"
        >
          {allCoverages.length > 0
            ? allCoverages.map(({ id, name }) => (
                <MenuItem key={id} value={name}>
                  {name}
                </MenuItem>
              ))
            : null}
        </StyledSelect>
      </FormControl>
    </Box>
  );
};

export default CoverageSelectionDropdown;
